import { FunctionalComponent, h } from "preact";
import { useState } from "preact/hooks";
import styles from "./styles.css";
interface IProps {
  showInfo: boolean;
  setShowInfo: (value: boolean) => void;
}
const InfoModal: FunctionalComponent<IProps> = ({ showInfo, setShowInfo }) => {
  return (
    <div>
      {/* Modal */}
      {showInfo && (
        <div className={styles.modal} onClick={() => setShowInfo(!showInfo)}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <span
              className={styles.close}
              onClick={() => setShowInfo(!showInfo)}
            >
              &times;
            </span>
            <h2>Korra.ai Knowledge Experience</h2>
            <p>
              <strong>Version:</strong> {__APP_VERSION__}
            </p>
            <p>
              <strong>Build:</strong> {__BUILD_TIME__}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoModal;
